import React from 'react';
import { Bot } from 'lucide-react';
import styles from './LoadingIndicator.module.scss';

const LoadingIndicator = () => {
  return (
    <div className={styles.loadingIndicator}>
      <Bot size={16} />
      <span>AI typing...</span>
    </div>
  );
};

export default LoadingIndicator;